import { useStore as useStoreShared, useStore } from './useStore';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BACKOFFICE_COOKIE, loggedIn } from '../utils/Cookie';
export function useReportStore() {
    const { clientViewStore, login } = useStoreShared();
    const { orderId } = useParams();
    useEffect(() => {
        //TODO: remove this `if` when report is only reachable from /report/:orderId
        if (orderId) {
            //If valid backOffice cookie then login here with backOffice cookie
            if (loggedIn(BACKOFFICE_COOKIE)) {
                login(BACKOFFICE_COOKIE);
            }
            clientViewStore.reportStore.fetchOrder(Number(orderId));
        }
    }, [orderId]);
    return clientViewStore;
}
export function useReportStore2() {
    const { individualViewStore, login } = useStore();
    const { orderId } = useParams();
    useEffect(() => {
        //TODO: remove this `if` when report is only reachable from /report/:orderId
        if (orderId) {
            //If valid backOffice cookie then login here with backOffice cookie
            if (loggedIn(BACKOFFICE_COOKIE)) {
                login(BACKOFFICE_COOKIE);
            }
            individualViewStore.reportStore.fetchOrder(Number(orderId));
        }
    }, [orderId]);
    return individualViewStore;
}
